import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { PrismSelectInput } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import type {
  CostBreakdown,
  CostBreakdownOption,
} from 'lumen/utils/net-revenue/cost-breakdowns';

interface HotelNetRevenueCostBreakdownSelectorSignature {
  Args: {
    onChange: (option: { id: CostBreakdown } | null) => void;
    options: CostBreakdownOption[];
    value: CostBreakdownOption | undefined;
  };
}

const HotelNetRevenueCostBreakdownSelector = <template>
  <div
    class="flex items-center gap-200"
    data-test-id="cost-drilldown-breakdown"
  >
    <span aria-hidden="true" class="text-300--regular">{{t
        "general.breakdown"
      }}</span>
    <PrismSelectInput
      @onChange={{@onChange}}
      @options={{@options}}
      @value={{@value}}
      aria-label={{concat (t "general.breakdown") ": " @value.label}}
    />
  </div>
</template> satisfies TOC<HotelNetRevenueCostBreakdownSelectorSignature>;

export default HotelNetRevenueCostBreakdownSelector;
